// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c6729ed5","160":"7c7e60fb","208":"d5e170c1","293":"1cc0f262","516":"2bd89a48","519":"28b402bc","917":"ff8b0732","946":"866e07ad"}[chunkId] + ".chunk.js";
};